"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var EmptyGameList = function (props) {
    var _a = (0, react_1.useState)(), value = _a[0], setValue = _a[1];
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    (0, react_1.useEffect)(function () {
        setValue(props.caption);
    }, [props]);
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { className: "__alphabet" }, props.caption),
        react_1.default.createElement("div", { className: "__empty-game-list " },
            react_1.default.createElement("div", { className: "__game-not-found-caption" }, t("page.index.caption-not-found")),
            react_1.default.createElement("div", { onClick: props.onBackClick, className: "__to-all-game" },
                react_1.default.createElement("img", { src: "/images/app/page/order/arrow-back.svg" }),
                t("page.index.empty-game-list.button")))));
};
exports.default = EmptyGameList;
